import { FormatClearRounded } from '@mui/icons-material';
import { ToggleButton, Tooltip } from '@mui/material';
import useMark from '../hooks/useMark';
import { useTranslation } from 'react-i18next';

function RemoveFormat() {
    const { clearMarks } = useMark();
    const { t } = useTranslation();

    return (
        <Tooltip title={t('Clear Formatting')}>
            <ToggleButton
                value={false}
                onMouseDown={e => {
                    e.preventDefault();
                    clearMarks();
                }}
            >
                <FormatClearRounded fontSize="small" />
            </ToggleButton>
        </Tooltip>
    );
}

export default RemoveFormat;
